import WelcomeSection from '@/components/WelcomeSection'
import ProductsOverviewCard from '@/components/card/ProductsOverviewCard'
import GuideCard from '@/components/card/GuideCard'
import LicenseCard from '@/components/card/LicenseCard'
import FAQCard from '@/components/card/FAQCard'
import SupportCard from '@/components/card/SupportCard'

export default function HomePage() {
  return (
    <div className="max-w-6xl mx-auto">
      <WelcomeSection />
      <ProductsOverviewCard />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <GuideCard />
        <LicenseCard />
        <FAQCard />
        <SupportCard />
      </div>
    </div>
  )
}
